module.exports = __webpack_public_path__ + "static/media/Entel.166c071f.png";